//@ts-nocheck TS6133
/* eslint-disable @typescript-eslint/no-duplicate-imports */
import type * as Types from 'owa-graph-schema';
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { BookingSchedulingPolicyFragmentFragmentDoc } from './BookingSchedulingPolicyFragment.interface';
import { BookingSettingsFragmentFragmentDoc } from './BookingSettingsFragment.interface';
export type BookingBusinessPageFragmentFragment = {
    __typename?: 'BookingBusinessEntry';
    isPublished?: boolean | null;
    schedulingPolicy?: {
        __typename?: 'BookingSchedulingPolicy';
        allowStaffSelection?: boolean | null;
        maximumAdvance?: string | null;
        minimumLeadTime?: string | null;
        sendConfirmationsToOwner?: boolean | null;
        sendMeetingInviteToCustomer?: boolean | null;
        timeSlotInterval?: string | null;
        hasCustomServiceWindows?: boolean | null;
        bookingServiceWindows?: Array<{
            __typename?: 'BookingServiceWindow';
            startDate?: string | null;
            endDate?: string | null;
            bookableHours?: Array<{
                __typename?: 'BookingWorkHours';
                day?: string | null;
                timeSlots?: Array<{
                    __typename?: 'BookingsWorkTimeSlot';
                    start?: number | null;
                    end?: number | null;
                } | null> | null;
            } | null> | null;
        } | null> | null;
    } | null;
    settings?: {
        __typename?: 'BookingSettings';
        otpVerificationSetting?: Types.BookingOtpSettings | null;
        publishingUrl?: string | null;
        c2RevampedEnabled?: boolean | null;
        authType?: Types.BookingSelfServicePageAuthType | null;
        friendlyUrl?: string | null;
        isLogoHidden?: boolean | null;
        isConsentNeeded?: boolean | null;
        consentText?: string | null;
        customColorScheme?: string | null;
        isSearchEngineIndexabilityDisabled?: boolean | null;
        showTimeSlotsInBusinessTimeZone?: boolean | null;
        emailVerificationMethod?: Types.BookingEmailVerificationMethod | null;
        sendMeetingInviteToCustomer?: boolean | null;
        onDemandServicesSetting?: Types.BookingOnDemandServicesSettings | null;
        themeData?: {
            __typename?: 'BookingThemeData';
            paletteId?: number | null;
            patternId?: number | null;
            pictureId?: number | null;
        } | null;
    } | null;
};
export const BookingBusinessPageFragmentFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BookingBusinessPageFragment' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'BookingBusinessEntry' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'schedulingPolicy' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: {
                                        kind: 'Name',
                                        value: 'BookingSchedulingPolicyFragment',
                                    },
                                },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'settings' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'BookingSettingsFragment' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...BookingSchedulingPolicyFragmentFragmentDoc.definitions,
        ...BookingSettingsFragmentFragmentDoc.definitions,
    ],
} as unknown as DocumentNode<BookingBusinessPageFragmentFragment, unknown>;
